import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import { env } from 'env';

export const GetReport = async (keyConfer, setReports) => {

 
  setReports(0);
  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_GET_REPORT_WITH_SMS}`,
    false,
    {
      keyConfer,
    }
  ).then((response) => {
     if (response.data.resCode === 1) {
       setReports(response.data.Data.PatientTurnList);
    } else {
      SwalAlert('error', response.data.resMessage, false);
      setReports(null);
    }
  });
};
